/**
 * MIRA Select Component
 * Wraps Shadcn Select with MIRA design system styles
 */

import React from 'react';
import {
  Select as ShadcnSelect,
  SelectGroup as ShadcnSelectGroup,
  SelectValue as ShadcnSelectValue,
  SelectTrigger as ShadcnSelectTrigger,
  SelectContent as ShadcnSelectContent,
  SelectLabel as ShadcnSelectLabel,
  SelectItem as ShadcnSelectItem,
  SelectSeparator as ShadcnSelectSeparator,
  SelectScrollUpButton as ShadcnSelectScrollUpButton,
  SelectScrollDownButton as ShadcnSelectScrollDownButton,
} from '@/components/ui/select';
import { cn } from '@/lib/utils';
import styles from '@/styles/components/select.module.css';

export const Select = ({ children, ...props }) => {
  return <ShadcnSelect {...props}>{children}</ShadcnSelect>;
};

export const SelectGroup = ShadcnSelectGroup;
export const SelectValue = ShadcnSelectValue;

export const SelectTrigger = React.forwardRef(
  ({ className, hasIcon, ...props }, ref) => {
    // Apply inline style for icon spacing when hasIcon prop is true
    // Inline styles override !important from CSS, ensuring consistent icon spacing
    const style = hasIcon ? { paddingLeft: 'calc(0.75rem + 2rem)' } : undefined; // 44px total (12px + 32px)

    return (
      <ShadcnSelectTrigger
        ref={ref}
        className={cn(styles.miraSelectTrigger, className)}
        style={style}
        {...props}
      />
    );
  }
);

SelectTrigger.displayName = 'MiraSelectTrigger';

export const SelectContent = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnSelectContent
        ref={ref}
        className={cn(styles.miraSelectContent, className)}
        {...props}
      />
    );
  }
);

SelectContent.displayName = 'MiraSelectContent';

export const SelectLabel = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnSelectLabel
        ref={ref}
        className={cn(styles.miraSelectLabel, className)}
        {...props}
      />
    );
  }
);

SelectLabel.displayName = 'MiraSelectLabel';

export const SelectItem = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnSelectItem
        ref={ref}
        className={cn(styles.miraSelectItem, className)}
        {...props}
      />
    );
  }
);

SelectItem.displayName = 'MiraSelectItem';

export const SelectSeparator = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnSelectSeparator
        ref={ref}
        className={cn(styles.miraSelectSeparator, className)}
        {...props}
      />
    );
  }
);

SelectSeparator.displayName = 'MiraSelectSeparator';

export const SelectScrollUpButton = ShadcnSelectScrollUpButton;
export const SelectScrollDownButton = ShadcnSelectScrollDownButton;
